export default {
  video: ({ showId, episodeId }) => [showId, episodeId, 'headliner'],
};
